export default "__VITE_ASSET__af1c5dc6__"